import classNames from 'classnames';
import { getInitial, generateColorGradient } from '../core/Avatar/avatarColor';
import './index.less';

const InitialsProfileImage = ({ firstName = ' ', lastName = ' ', extraImgAttributes }) => {
    let firstNameInitial = getInitial(firstName || '');
    const lastNameInitial = getInitial(lastName || '');
    if (firstNameInitial === ' ' && lastNameInitial === ' ') {
        firstNameInitial = '?';
    }

    const colorGradient = generateColorGradient(firstNameInitial, lastNameInitial);
    
    const extraStyle = extraImgAttributes?.style || {};
    const mergedStyle = { 
        ...extraStyle,
        background: colorGradient 
    };
    
    const { style: _, ...otherAttributes } = extraImgAttributes || {};
    
    return (
        <div className='img' style={mergedStyle} {...otherAttributes}>
            {firstNameInitial + lastNameInitial}
        </div>
    );
};

const ProfileImage = ({ photoUrl, firstName, lastName, options = {}, onClick }) => {
    const tooltipClass = options.tooltipClass || 'tooltip-small';
    const tooltipRegex = new RegExp(`class=.${tooltipClass}`);
    const tooltip = options.tooltip || '';
    const extraClasses = options.extraClasses || '';
    const extraAttributes = options.extraAttributes || '';
    const extraImgAttributes = options.extraImgAttributes || '';
    
    return (
        <div
            className={classNames('navbar-portrait', extraClasses, {
                [`has-${tooltipClass}`]: tooltip,
            })}
            {...extraAttributes} onClick={onClick}
        >
            {photoUrl ? (
                window.cachedImages.has(photoUrl) ? (
                    <div
                        className='img'
                        style={{ 
                            backgroundImage: `url(${photoUrl})`,
                            ...(extraImgAttributes?.style || {})
                        }}
                        {...(extraImgAttributes ? (({ style, ...rest }) => rest)(extraImgAttributes) : {})}
                    ></div>
                ) : (
                    <div 
                        className='img skeleton-box' 
                        data-src={photoUrl} 
                        {...extraImgAttributes}
                    ></div>
                )
            ) : (
                <InitialsProfileImage
                    firstName={firstName}
                    lastName={lastName}
                    extraImgAttributes={extraImgAttributes}
                />
            )}
            {tooltip &&
                (tooltipRegex.test(tooltip) ? (
                    sanitizeTheHtml(tooltip)
                ) : (
                    <span className={tooltipClass}>{sanitizeTheHtml(tooltip)}</span>
                ))}
        </div>
    );
};

export default ProfileImage;